import {Component} from '@angular/core';

@Component({
    templateUrl: './emptydemo.html'
})
export class EmptyDemo {
}